import { RouteObject } from "react-router-dom";
import HomePage from "@/pages/home/page";
import RegisterPage from "@/pages/register/page";
import CommunityPage from "@/pages/community/page";
import DashboardPage from "@/pages/dashboard/page";
import ProgramsPage from "@/pages/programs/page";
import PaymentPage from "@/pages/payment/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/register", element: <RegisterPage /> },
  { path: "/community", element: <CommunityPage /> },
  { path: "/dashboard", element: <DashboardPage /> },
  { path: "/programs", element: <ProgramsPage /> },
  { path: "/payment", element: <PaymentPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
